export default "__VITE_ASSET__16ef72af__"